import { z } from 'zod';
/**
 * Payload shape for `GET /api/dashboard/charger-uptime`.
 *
 * Two numbers + a 24-bucket sparkline. The "now" number reads
 * from the same heartbeat-cutoff formula the operator dashboard
 * uses for its network ring; the historical sparkline is
 * reconstructed from OcppMessage activity since no
 * ChargerStatusHistory model exists today.
 *
 * Fidelity caveat: each hourly bucket reads "online during this
 * hour" as "sent at least one OCPP message in this hour."
 * Heartbeats fire every 60-300s so an online charger will be
 * present in every bucket; a charger that flapped mid-hour shows
 * as fully up. Acceptable for an at-a-glance widget. Richer
 * fidelity needs a real status-transition history (filed for
 * future).
 */
export const ChargerUptimeResponseSchema = z.object({
    /** Percent online right now (0-100). Same formula as the
     *  operator dashboard's network ring: `is_active && is_online
     *  && last_heartbeat >= now - 15min`. */
    percent_online_now: z.number().min(0).max(100),
    /** Hourly online-percent buckets, oldest hour first. Index 0
     *  is 24h ago, index 23 is the most recent completed hour.
     *  Each value is 0-100. Null when no chargers are in scope
     *  (avoids dividing by zero on the historical proxy). */
    sparkline_buckets: z.array(z.number().min(0).max(100)).length(24).nullable(),
    /** Total active chargers in the caller's scope. Drives the
     *  "X / Y online" subtitle and the empty-state branch when
     *  the count is 0. */
    total_chargers: z.number().int().nonnegative(),
    /** True for third_party_admin (or any other AccessAssignment-
     *  scoped caller). Drives empty-state copy. */
    is_scoped: z.boolean(),
    generated_at: z.string(),
});
//# sourceMappingURL=dashboard-charger-uptime.js.map